import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const DocumentList = ({ language, selectedFolder, onDocumentSelect }) => {
  const [viewMode, setViewMode] = useState('list');
  const [sortBy, setSortBy] = useState('date');

  const documents = [
  {
    id: 'doc-001',
    nameEn: 'Commercial Lease Agreement - Benali Properties',
    nameFr: 'Contrat de bail commercial - Propriétés Benali',
    nameAr: 'عقد إيجار تجاري - عقارات بنعلي',
    type: 'PDF',
    size: '2.4 MB',
    createdDate: '2026-01-25',
    modifiedDate: '2026-01-26',
    version: '3.0',
    owner: 'Ahmed Benali',
    ownerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f3d3c1c0-1763292343202.png",
    ownerAvatarAlt: 'Professional headshot of Ahmed Benali, Moroccan lawyer with short black hair wearing navy suit and red tie',
    folder: 'client-contracts',
    tags: ['Contract', 'Commercial', 'Active'],
    icon: 'FileText',
    color: 'text-error'
  },
  {
    id: 'doc-002',
    nameEn: 'Court Pleading - Case #2024-156',
    nameFr: 'Plaidoirie - Dossier #2024-156',
    nameAr: 'مرافعة المحكمة - القضية #2024-156',
    type: 'DOCX',
    size: '1.8 MB',
    createdDate: '2026-01-24',
    modifiedDate: '2026-01-25',
    version: '2.1',
    owner: 'Fatima Zahra',
    ownerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1412616e4-1763297452253.png",
    ownerAvatarAlt: 'Professional headshot of Fatima Zahra, Moroccan lawyer with long black hair wearing black blazer and white blouse',
    folder: 'case-pleadings',
    tags: ['Pleading', 'Urgent', 'Draft'],
    icon: 'FileText',
    color: 'text-primary'
  },
  {
    id: 'doc-003',
    nameEn: 'Evidence Documentation - Property Dispute',
    nameFr: 'Documentation de preuve - Litige immobilier',
    nameAr: 'توثيق الأدلة - نزاع عقاري',
    type: 'PDF',
    size: '5.6 MB',
    createdDate: '2026-01-23',
    modifiedDate: '2026-01-24',
    version: '1.0',
    owner: 'Youssef Alami',
    ownerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ab0d1b30-1763294303279.png",
    ownerAvatarAlt: 'Professional headshot of Youssef Alami, Moroccan lawyer with short brown hair and beard wearing gray suit',
    folder: 'case-evidence',
    tags: ['Evidence', 'Property', 'Confidential'],
    icon: 'FileText',
    color: 'text-error'
  },
  {
    id: 'doc-004',
    nameEn: 'Client Identification - National ID Copy',
    nameFr: 'Identification client - Copie CIN',
    nameAr: 'هوية العميل - نسخة البطاقة الوطنية',
    type: 'JPG',
    size: '856 KB',
    createdDate: '2026-01-22',
    modifiedDate: '2026-01-22',
    version: '1.0',
    owner: 'Samira Bennani',
    ownerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1412616e4-1763297452253.png",
    ownerAvatarAlt: 'Professional headshot of Samira Bennani, Moroccan secretary with shoulder-length black hair wearing burgundy blouse',
    folder: 'client-identification',
    tags: ['ID', 'Client', 'Verified'],
    icon: 'Image',
    color: 'text-warning'
  },
  {
    id: 'doc-005',
    nameEn: 'Employment Contract Template',
    nameFr: 'Modèle de contrat de travail',
    nameAr: 'نموذج عقد العمل',
    type: 'DOCX',
    size: '345 KB',
    createdDate: '2026-01-20',
    modifiedDate: '2026-01-26',
    version: '4.2',
    owner: 'Ahmed Benali',
    ownerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f3d3c1c0-1763292343202.png",
    ownerAvatarAlt: 'Professional headshot of Ahmed Benali, Moroccan lawyer with short black hair wearing navy suit and red tie',
    folder: 'template-contracts',
    tags: ['Template', 'Employment', 'Standard'],
    icon: 'FileText',
    color: 'text-primary'
  },
  {
    id: 'doc-006',
    nameEn: 'Invoice #INV-2024-089',
    nameFr: 'Facture #INV-2024-089',
    nameAr: 'الفاتورة #INV-2024-089',
    type: 'PDF',
    size: '678 KB',
    createdDate: '2026-01-19',
    modifiedDate: '2026-01-19',
    version: '1.0',
    owner: 'Samira Bennani',
    ownerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1412616e4-1763297452253.png",
    ownerAvatarAlt: 'Professional headshot of Samira Bennani, Moroccan secretary with shoulder-length black hair wearing burgundy blouse',
    folder: 'invoices',
    tags: ['Invoice', 'Paid', 'Archived'],
    icon: 'FileText',
    color: 'text-error'
  },
  {
    id: 'doc-007',
    nameEn: 'Court Judgment - Final Decision',
    nameFr: 'Jugement du tribunal - Décision finale',
    nameAr: 'حكم المحكمة - القرار النهائي',
    type: 'PDF',
    size: '3.2 MB',
    createdDate: '2026-01-18',
    modifiedDate: '2026-01-18',
    version: '1.0',
    owner: 'Fatima Zahra',
    ownerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1412616e4-1763297452253.png",
    ownerAvatarAlt: 'Professional headshot of Fatima Zahra, Moroccan lawyer with long black hair wearing black blazer and white blouse',
    folder: 'case-judgments',
    tags: ['Judgment', 'Final', 'Important'],
    icon: 'FileText',
    color: 'text-error'
  },
  {
    id: 'doc-008',
    nameEn: 'Client Correspondence - Email Thread',
    nameFr: 'Correspondance client - Fil d\'emails',
    nameAr: 'مراسلات العميل - سلسلة البريد الإلكتروني',
    type: 'PDF',
    size: '1.1 MB',
    createdDate: '2026-01-17',
    modifiedDate: '2026-01-25',
    version: '2.0',
    owner: 'Youssef Alami',
    ownerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ab0d1b30-1763294303279.png",
    ownerAvatarAlt: 'Professional headshot of Youssef Alami, Moroccan lawyer with short brown hair and beard wearing gray suit',
    folder: 'client-correspondence',
    tags: ['Email', 'Client', 'Recent'],
    icon: 'FileText',
    color: 'text-error'
  }];


  const getName = (doc) => {
    if (language === 'fr') return doc?.nameFr;
    if (language === 'ar') return doc?.nameAr;
    return doc?.nameEn;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (language === 'ar') {
      return date?.toLocaleDateString('ar-MA');
    }
    return date?.toLocaleDateString('fr-MA');
  };

  const getFileIcon = (type) => {
    switch (type?.toUpperCase()) {
      case 'PDF':return 'FileText';
      case 'DOCX':case 'DOC':return 'FileText';
      case 'JPG':case 'PNG':case 'JPEG':return 'Image';
      case 'XLS':case 'XLSX':return 'FileSpreadsheet';
      default:return 'File';
    }
  };

  const filteredDocuments = selectedFolder === 'root' ?
  documents :
  documents?.filter((doc) => doc?.folder === selectedFolder);

  const sortedDocuments = [...filteredDocuments]?.sort((a, b) => {
    if (sortBy === 'date') {
      return new Date(b.modifiedDate) - new Date(a.modifiedDate);
    }
    if (sortBy === 'name') {
      return getName(a)?.localeCompare(getName(b));
    }
    if (sortBy === 'size') {
      return parseFloat(b?.size) - parseFloat(a?.size);
    }
    return 0;
  });

  const viewModeLabel = {
    en: 'View',
    fr: 'Vue',
    ar: 'عرض'
  };

  const sortLabel = {
    en: 'Sort by',
    fr: 'Trier par',
    ar: 'ترتيب حسب'
  };

  const nameLabel = {
    en: 'Name',
    fr: 'Nom',
    ar: 'الاسم'
  };

  const typeLabel = {
    en: 'Type',
    fr: 'Type',
    ar: 'النوع'
  };

  const sizeLabel = {
    en: 'Size',
    fr: 'Taille',
    ar: 'الحجم'
  };

  const modifiedLabel = {
    en: 'Modified',
    fr: 'Modifié',
    ar: 'تاريخ التعديل'
  };

  const ownerLabel = {
    en: 'Owner',
    fr: 'Propriétaire',
    ar: 'المالك'
  };

  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center justify-between gap-4 mb-4 pb-4 border-b border-border flex-wrap">
        <div className="flex items-center gap-2">
          <span className="text-sm text-muted-foreground">
            {viewModeLabel?.[language]}:
          </span>
          <div className="flex gap-1 bg-muted rounded-lg p-1">
            <button
              className={`p-2 rounded transition-colors ${
              viewMode === 'list' ? 'bg-background shadow-sm' : 'hover:bg-background/50'}`
              }
              onClick={() => setViewMode('list')}
              aria-label="List view">

              <Icon name="List" size={18} />
            </button>
            <button
              className={`p-2 rounded transition-colors ${
              viewMode === 'grid' ? 'bg-background shadow-sm' : 'hover:bg-background/50'}`
              }
              onClick={() => setViewMode('grid')}
              aria-label="Grid view">

              <Icon name="Grid" size={18} />
            </button>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <span className="text-sm text-muted-foreground">
            {sortLabel?.[language]}:
          </span>
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e?.target?.value)}
            className="px-3 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-ring">

            <option value="date">{modifiedLabel?.[language]}</option>
            <option value="name">{nameLabel?.[language]}</option>
            <option value="size">{sizeLabel?.[language]}</option>
          </select>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto">
        {viewMode === 'list' ?
        <div className="space-y-2">
            {sortedDocuments?.map((doc) =>
          <div
            key={doc?.id}
            className="flex items-center gap-4 p-4 bg-card border border-border rounded-lg hover:shadow-elevation-sm transition-all cursor-pointer"
            onClick={() => onDocumentSelect(doc)}>

                <div className={`flex-shrink-0 ${doc?.color}`}>
                  <Icon name={getFileIcon(doc?.type)} size={24} />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-medium text-foreground truncate">
                    {getName(doc)}
                  </h4>
                  <div className="flex items-center gap-3 mt-1 text-xs text-muted-foreground flex-wrap">
                    <span>{doc?.type}</span>
                    <span>•</span>
                    <span>{doc?.size}</span>
                    <span>•</span>
                    <span>{formatDate(doc?.modifiedDate)}</span>
                    <span>•</span>
                    <span>v{doc?.version}</span>
                  </div>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <Image
                src={doc?.ownerAvatar}
                alt={doc?.ownerAvatarAlt}
                className="w-8 h-8 rounded-full object-cover" />

                  <span className="text-sm text-muted-foreground hidden md:block">
                    {doc?.owner}
                  </span>
                </div>
                <button
              className="p-2 hover:bg-muted rounded-lg transition-colors flex-shrink-0"
              onClick={(e) => {
                e?.stopPropagation();
                console.log('More options', doc?.id);
              }}
              aria-label="More options">

                  <Icon name="MoreVertical" size={18} />
                </button>
              </div>
          )}
          </div> :

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {sortedDocuments?.map((doc) =>
          <div
            key={doc?.id}
            className="bg-card border border-border rounded-lg p-4 hover:shadow-elevation-sm transition-all cursor-pointer"
            onClick={() => onDocumentSelect(doc)}>

                <div className={`flex items-center justify-center h-24 mb-3 ${doc?.color}`}>
                  <Icon name={getFileIcon(doc?.type)} size={48} />
                </div>
                <h4 className="text-sm font-medium text-foreground truncate mb-2">
                  {getName(doc)}
                </h4>
                <div className="flex items-center justify-between text-xs text-muted-foreground">
                  <span>{doc?.type}</span>
                  <span>{doc?.size}</span>
                </div>
                <div className="flex items-center gap-2 mt-3 pt-3 border-t border-border">
                  <Image
                src={doc?.ownerAvatar}
                alt={doc?.ownerAvatarAlt}
                className="w-6 h-6 rounded-full object-cover" />

                  <span className="text-xs text-muted-foreground truncate flex-1">
                    {doc?.owner}
                  </span>
                </div>
              </div>
          )}
          </div>
        }
      </div>
    </div>);

};

export default DocumentList;